export var getBaseItemStyle = function getBaseItemStyle() {
  return {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.200',
    padding: '10px 8px',
    '&:last-child': {
      borderBottomColor: 'transparent'
    }
  };
};
export var getHeaderBaseStyle = function getHeaderBaseStyle() {
  return {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.200',
    '&:last-child': {
      borderBottomColor: 'transparent'
    }
  };
};
export var getFooterBaseStyle = function getFooterBaseStyle() {
  return {
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'grey.200',
    '&:first-child': {
      borderTopColor: 'transparent'
    }
  };
};